"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("../../../FoodMenu.context");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

var _item = require("../item");

var CategoryColumn = function CategoryColumn(_ref) {
  var categoryId = _ref.categoryId;
  return _react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var categories = _ref2.categories,
        items = _ref2.items;

    var category = _menu["default"].getCategoryById(categories, categoryId);

    var categoryItemIds = category.items;

    var categoryItems = _menu["default"].getCategoryItems(categoryItemIds, items);

    var name = category.name,
        description = category.description;
    return _react["default"].createElement(_semanticUiReact.Grid.Column, null, _react["default"].createElement(_semanticUiReact.Header, {
      as: "h3",
      icon: true,
      style: {
        textAlign: 'left'
      }
    }, name, _react["default"].createElement(_semanticUiReact.Header.Subheader, null, description)), _react["default"].createElement("div", {
      style: {
        padding: '0.75rem 2.5% 0 2.5%'
      }
    }, _react["default"].createElement(_semanticUiReact.List, null, categoryItems.map(function (_ref3) {
      var id = _ref3.id;
      return _react["default"].createElement(_item.ItemContainer, {
        itemId: id,
        showDescription: false,
        showModifierSets: false
      });
    }))));
  });
};

var _default = CategoryColumn;
exports["default"] = _default;